import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Spinner } from "./styles/full-screen-loading-styles";
import spinner from "./img/loading.gif";

const FullScreenLoading = ({ noMobile }) => (
  <Wrapper noMobile={noMobile}>
    <Spinner
      src={spinner}
      alt="Loading spinner"
      data-test-id="loading-spinner"
    />
  </Wrapper>
);

FullScreenLoading.propTypes = {
  noMobile: PropTypes.bool,
};

FullScreenLoading.defaultProps = {
  noMobile: PropTypes.isNull,
};

export default FullScreenLoading;
